import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { useLang } from '../i18n/translations';
import { codeInfo } from './WeatherWidget';

export const EventWeather = ({ lat, lng, date, showLabel = false }) => {
  const { t } = useLang();
  const [w, setW] = useState(null);

  useEffect(() => {
    let ok = true;
    api.get(`/event-weather?lat=${lat}&lng=${lng}&date=${date}`)
      .then(({ data }) => { if (ok) setW(data); })
      .catch(() => {});
    return () => { ok = false; };
  }, [lat, lng, date]);

  if (!w?.available || w.tmax == null) return null;
  const info = codeInfo(w.weather_code);
  const Icon = info.icon;

  return (
    <span className="inline-flex items-center gap-1.5 text-slate-500" title={t(info.key)} data-testid="event-weather">
      <Icon className="h-4 w-4 text-[#001752]" strokeWidth={1.75} />
      <span className="text-xs font-semibold whitespace-nowrap">
        {Math.round(w.tmax)}° / {Math.round(w.tmin)}°
      </span>
      {showLabel && <span className="text-xs text-slate-400">· {t(info.key)}</span>}
    </span>
  );
};
